var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"iv-paragraph"},[_vm._v("このアンケートは委託先である株式会社マーケティングセンターにより運営されています。")])])}]

export { render, staticRenderFns }